import { useEffect } from 'react'
import { i18nextInit } from '../lang-config'

const useInitLang = ({ i18n, en, es, pt }) => {
  useEffect(() => {
    const initConf = i18nextInit({ en, es, pt })
    i18n.init(initConf)

    if (localStorage.getItem('lang')) {
      i18n.changeLanguage(localStorage.getItem('lang'))
    }
  }, [])

  useEffect(() => {
    addEventListener('CHANGE_LANG', (e: CustomEvent) => {
      i18n.changeLanguage(e.detail)
    })
  }, [])

  return i18n
}

export { useInitLang }
